export enum SystemPresenceType {
  Available = 'AVAILABLE',
  Away = 'AWAY',
  Busy = 'BUSY',
  Offline = 'OFFLINE',
  Idle = 'IDLE',
  OnQueue = 'ON_QUEUE',
  Meal = 'MEAL',
  Training = 'TRAINING',
  Meeting = 'MEETING',
  Break = 'BREAK'
}

export interface SystemPresence {
  id: string;
  name: SystemPresenceType;
}
